import { scroller } from "@/core/resource";
import eventTypes from "@/events/event-types";
var InfoGraphic = /** @class */ (function () {
    function InfoGraphic(el) {
        this._el = el;
    }
    InfoGraphic.prototype.setup = function () {
        this._setAnimation();
        this._setNativeEvents();
    };
    InfoGraphic.prototype.teardown = function () {
        delete this._el;
        this._clearNativeEvents();
    };
    InfoGraphic.prototype._setAnimation = function () {
        console.log("[call] InfoGraphic");
    };
    InfoGraphic.prototype._animate = function () {
        this._timeline.play();
    };
    InfoGraphic.prototype._setNativeEvents = function () {
        var _this = this;
        this._onScroll = function () {
            if (_this._checkEnter()) {
                scroller.removeEventListener(eventTypes.SCROLL, _this._onScroll);
                _this._animate();
            }
        };
        scroller.addEventListener(eventTypes.SCROLL, this._onScroll);
    };
    InfoGraphic.prototype._clearNativeEvents = function () {
        scroller.removeEventListener(eventTypes.SCROLL, this._onScroll);
    };
    /**
     * 画面内に入ったから調べる
     */
    InfoGraphic.prototype._checkEnter = function () {
        var documentElement = document.documentElement;
        var scrollTop = scroller.scrollTop;
        var borderLine = this._el.getBoundingClientRect().top +
            scrollTop -
            documentElement.clientHeight * 0.8;
        return borderLine < scrollTop;
    };
    return InfoGraphic;
}());
export default InfoGraphic;
